import React from 'react';

/**
 * Calvio Logo - High quality with responsive image loading
 * Uses srcset for better quality on high-DPI displays
 */
const CalvioLogo = ({ size = 52, className = '' }) => {
  return (
    <img 
      src="/logo_original.png"
      srcSet="/calvio_logo.png 1x, /logo_original.png 2x"
      alt="Calvio"
      width={size}
      height={size}
      className={`object-contain ${className}`}
      style={{ width: size, height: size }}
      loading="eager"
      decoding="async"
    />
  );
};

// Optimized for smaller sizes
export const CalvioLogoSimple = ({ size = 36, className = '' }) => {
  return (
    <img 
      src="/calvio_logo.png"
      srcSet="/calvio_logo.png 1x, /logo_original.png 2x"
      alt="Calvio"
      width={size}
      height={size}
      className={`object-contain ${className}`}
      style={{ width: size, height: size }}
      loading="lazy"
      decoding="async"
    />
  );
};

export const CalvioIcon = ({ size = 24, className = '' }) => {
  return (
    <img 
      src="/calvio_logo.png"
      srcSet="/calvio_logo.png 1x, /calvio_logo_new.png 2x"
      alt="Calvio"
      width={size}
      height={size}
      className={`object-contain ${className}`}
      style={{ width: size, height: size }}
      loading="lazy"
      decoding="async"
    />
  );
};

export default CalvioLogo;
